export const ACTIONS = {
    INPUT_DIGIT: 'input-digit'
    , CHOOSE_OPERATION: 'choose-operation'
    , CLEAR: 'clear'
    , EVALUATE: 'evaluate'
    , SPECIALTY: 'specialty'
};
